import { styled } from 'styled-components';

import { ScCategoriesWrapper } from '@/components/TabNavigation/styled';
import { ScQRCode } from '@/modules/profile/security/styled';
import { device, typography } from '@/styles/helpers';

export const ScStepsContainer = styled.div`
  background-color: ${({ theme }) => theme.grayDarkColor};
  border-radius: 24px;
  padding: 24px 16px;
  margin-top: 16px;
`;

export const ScMobileAppPageContainer = styled.div`
  & ${ScCategoriesWrapper} {
    margin-bottom: 32px;
  }
`;

export const ScTitle = styled.p`
  ${typography['headline1']};
  text-align: center;
  margin: 0 auto 16px;
  text-transform: uppercase;
  max-width: 800px;
  width: 100%;

  @media (${device.mobile}) {
    ${typography['headline1mobile']};
  }
`;

export const ScDescription = styled.p`
  ${typography['body1regular']};
  text-align: center;
  margin: 0 auto 64px;
  white-space: pre-line;
  max-width: 800px;
  width: 100%;
`;

export const ScSteps = styled.div<{ cols: number }>`
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, 1fr)`};
  gap: 16px 24px;

  & > .step {
    display: grid;
    grid-template-rows: subgrid;
    grid-row: span 2;
  }

  & .step-img {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  & ${ScQRCode} {
    margin: 0 auto;
  }

  & svg,
  & img {
    display: block;
    margin: 0 auto;
  }

  @media (${device.mobile}) {
    grid-template-columns: repeat(1, 1fr);
  }

  & button {
    max-width: 280px;
    width: 100%;
    margin: 0 auto;
  }
`;

export const ScStepsTitle = styled.div`
  ${typography['headline2']};
  margin-bottom: 24px;
  text-align: center;
  text-transform: uppercase;

  @media (${device.mobile}) {
    ${typography['headline2mobile']};
  }
`;

export const ScStepNumber = styled.p`
  margin-bottom: 16px;
  text-align: center;
`;

export const ScStepTitle = styled.p`
  ${typography['body2regular']};
  text-align: center;
`;
